document.addEventListener('click', (e) => {
    if (e.target.closest('.js-go-up')) {
        window.scroll({
            top: 0,
            behavior: "smooth"
        })
    }
})
